module.exports = __webpack_public_path__ + "static/media/logo.0ace7e07.png";